
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'StatusTag',
    props: {
        label: {
            type: String,
            required: true
        },
        version: {
            type: String,
            required: true
        },
        isInverse: {
            type: Boolean,
            required: false,
            default: false
        },
        isSmall: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        className: function () {
            return `ob1-capsule-${this.version}`;
        },
        classes: function () {
            let classes = [this.className]
            if (this.isInverse) {
                classes.push('ob1-capsule-inverse')
            }
            if (this.isSmall) {
                classes.push('ob1-capsule-small')
            }
            return classes
        }
    }
});
